export const AVATAR_CATALOG = [
  { emoji: '👤', label: 'Default' },
  { emoji: '🦁', label: 'León' },
  { emoji: '🐯', label: 'Tigre' },
  { emoji: '🦊', label: 'Zorro' },
  { emoji: '🐻', label: 'Oso' },
  { emoji: '🐼', label: 'Panda' },
  { emoji: '🐨', label: 'Koala' },
  { emoji: '🐸', label: 'Rana' },
  { emoji: '🦄', label: 'Unicornio' },
  { emoji: '🐲', label: 'Dragón' },
  { emoji: '🌟', label: 'Estrella' },
  { emoji: '🎪', label: 'Circo' },
];

export function getAvatarEmoji(index) {
  return AVATAR_CATALOG[index]?.emoji || AVATAR_CATALOG[0].emoji;
}
